import React from 'react';
import { Outlet } from 'react-router-dom';

function LayoutNoHeader() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default LayoutNoHeader;
